import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { OngoingEvaluation } from '@/types';

interface OnGoingEvaluationsState {
  ongoingEvaluations: OngoingEvaluation[];
  isOngoingEvaluationsOpen: boolean;
}

const useOnGoingEvaluationsStore = create<
  OnGoingEvaluationsState & {
    addOngoingEvaluation: (ongoingEvaluation: OngoingEvaluation) => void;
    setOngoingEvaluations: (ongoingEvaluations: OngoingEvaluation[]) => void;
    setIsOngoingEvaluationsOpen: (isOngoingEvaluationsOpen: boolean) => void;
    removeOngoingEvaluation: (jobId: string) => void;
    clearAllOngoingEvaluations: () => void;
    updateEvaluations: (
      updates: Record<string, Partial<OngoingEvaluation>>,
    ) => void;
  }
>()(
  persist(
    (set) => ({
      ongoingEvaluations: [],
      isOngoingEvaluationsOpen: false,
      addOngoingEvaluation: (ongoingEvaluation: OngoingEvaluation) =>
        set((state) => ({
          ongoingEvaluations: [...state.ongoingEvaluations, ongoingEvaluation],
        })),
      setOngoingEvaluations: (ongoingEvaluations: OngoingEvaluation[]) =>
        set({ ongoingEvaluations }),
      setIsOngoingEvaluationsOpen: (isOngoingEvaluationsOpen: boolean) =>
        set({ isOngoingEvaluationsOpen }),
      removeOngoingEvaluation: (jobId: string) =>
        set((state) => ({
          ongoingEvaluations: state.ongoingEvaluations.filter(
            (evaluation) => evaluation.jobId !== jobId,
          ),
        })),
      clearAllOngoingEvaluations: () => set({ ongoingEvaluations: [] }),
      updateEvaluations: (updates) =>
        set((state) => ({
          ongoingEvaluations: state.ongoingEvaluations.map((evaluation) =>
            updates[evaluation.jobId]
              ? { ...evaluation, ...updates[evaluation.jobId] }
              : evaluation,
          ),
        })),
    }),
    {
      name: 'ongoing-evaluations',
      partialize: (state) => ({
        ongoingEvaluations: state.ongoingEvaluations,
      }),
    },
  ),
);

export default useOnGoingEvaluationsStore;
